import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IBankAccountNumbers } from '../models/models'

export class GetBankAccountsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/GetBankAccounts',
      requesterInfo,
    })
  }

  public async getBankAccounts(): Promise<IBankAccountNumbers[]> {
    return await this.getAsync<IBankAccountNumbers[]>()
  }
}
